import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Nächte damit verbracht Formulare von null zu erstellen.',
  good: 'Fertige KPI-Berichte in 2 Minuten ausdrucken und senden.'
}, {
  bad: 'Stress vor jeder VIP-Stunde ohne professionelles System.',
  good: 'Totale Sicherheit auf der Piste mit vollständigem System.'
}, {
  bad: 'Erklärungen die der Schüler nach 10 Minuten vergisst.',
  good: 'Biomechanische Field Cards die der Kunde seiner Familie zeigt.'
}, {
  bad: '100 CHF pro Stunde weil du wie alle anderen aussiehst.',
  good: '300 CHF pro Stunde weil du wie eine Akademie wirkst.'
}];
export function ComparisonTable() {
  return <section className="py-8 px-4" data-id="element-40">
      <div className="max-w-xl mx-auto" data-id="element-41">
        <div className="flex justify-between px-4 mb-4 text-xs font-bold uppercase tracking-wider text-brand-muted" data-id="element-42">
          <span className="w-1/2 text-left" data-id="element-43">Ohne Swiss Champions</span>
          <span className="w-1/2 text-left pl-4 border-l border-brand-border" data-id="element-44">
            Mit Swiss Champions
          </span>
        </div>
        <div className="space-y-3" data-id="element-45">
          {comparisons.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-surface border border-brand-border rounded-2xl p-4 flex flex-col sm:flex-row gap-4 sm:gap-0" data-id="element-46">
              <div className="flex gap-3 items-start sm:w-1/2 sm:pr-4" data-id="element-47">
                <div className="mt-0.5 bg-red-100 p-1 rounded-full shrink-0" data-id="element-48">
                  <XIcon className="w-4 h-4 text-red-600" strokeWidth={3} data-id="element-49" />
                </div>
                <p className="text-brand-muted font-medium text-sm sm:text-base" data-id="element-50">
                  {item.bad}
                </p>
              </div>
              <div className="hidden sm:block w-px bg-brand-border shrink-0" data-id="element-51" />
              <div className="flex gap-3 items-start sm:w-1/2 sm:pl-4" data-id="element-52">
                <div className="mt-0.5 bg-green-100 p-1 rounded-full shrink-0" data-id="element-53">
                  <CheckIcon className="w-4 h-4 text-green-600" strokeWidth={3} data-id="element-54" />
                </div>
                <p className="text-brand-navy font-bold text-sm sm:text-base" data-id="element-55">
                  {item.good}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-lg font-bold text-brand-gold mt-8 mb-6" data-id="element-56">
          Fang wieder an, den ersten Schneetag zu lieben.
        </motion.p>
      </div>
    </section>;
}